import { splitCarouselPhotos } from './photoUrls';

const typesToExclude = ['string'];

function getFormData(object, images = []) {
  const formData = new FormData();
  Object.keys(object).forEach((key) => {
    if (typesToExclude.includes(typeof object[key])) {
      formData.append(key, object[key]);
    } else {
      formData.append(key, JSON.stringify(object[key]));
    }
  });

  const { files, urls } = splitCarouselPhotos(images);
  files.forEach((image) => {
    formData.append('image', image.file || image);
  });
  if (urls.length) {
    formData.append('photo_urls', JSON.stringify(urls));
  }

  return formData;
}

export default getFormData;
